export function handleToggleFilterGroup() {
  $('.industry-group').click(handleToggleIndustryFilter)
  $('.solution-group').click(handleToggleSolutionFilter)
  $('.filter-item').click(handleFilterPosts)
}

let ajax

function handleToggleIndustryFilter() {
  $('.industry-group').toggleClass('active')
  $('.industry-categories').toggleClass('active')
  $('.solution-group').removeClass('active')
  $('.solution-categories').removeClass('active')
  $('.categories-wrap').find('.filter-item').removeClass('active')
  // eslint-disable-next-line
  $(`.categories-wrap .resource-industry[data-cta='all']`).addClass('active')
  getPosts({
    preRequest: preLoadPosts,
    category: 'resource_industries',
    term: 'all',
    page: 1,
  })
}

function handleToggleSolutionFilter() {
  $('.solution-group').toggleClass('active')
  $('.solution-categories').toggleClass('active')
  $('.industry-group').removeClass('active')
  $('.industry-categories').removeClass('active')
  $('.categories-wrap').find('.filter-item').removeClass('active')
  // eslint-disable-next-line
  $(`.categories-wrap .resource-solution[data-cta='all']`).addClass('active')
  getPosts({
    preRequest: preLoadPosts,
    category: 'resource_solutions',
    term: 'all',
    page: 1,
  })
}

function preLoadPosts() {
  $('.resource-wrap').addClass('d-none')
  $('.post-loading').removeClass('d-none')
}

function handleFilterPosts(e) {
  e.preventDefault()
  $('.categories-wrap').find('.filter-item').removeClass('active')
  $(this).toggleClass('active')
  let category = $(this).hasClass('resource-industry') ? 'resource_industries' : 'resource_solutions'
  let term = $(this).data('cta')
  getPosts({
    preRequest: preLoadPosts,
    category,
    term,
    page: 1,
  });
}

// function handleClickLoadMoreButton() {
//   const page = Number($('.post-grid-block').attr('data-page')) + 1
//   let category = $('.filter-selected').attr('data-cta')
//   getPosts({ page: page, category })
// }

function getPosts({ page, category, term, preRequest }) {
  if (ajax) {
    ajax.abort()
  }

  !!preRequest && preRequest()

  const postBlock = $('.resource-listing-block')
  const noPostsFoundMessage = postBlock.data('no-posts-found-message') || 'No Posts Found.'
  const postList = $('.resource-wrap')
  const loadMoreWrap = $('.load-more-wrap')
  const loadMoreButton = loadMoreWrap.find('.load-more')
  const loadingIndicator = loadMoreWrap.find('.loading-spinner')
  let url = new URL(window.location.href)
  url.searchParams.append('paged', page)

  if (category) url.href += '&cat=' + category
  if (term) url.href += '&term=' + term
  if (page > 1) {
    loadMoreButton.addClass('d-none').attr('disabled', 'disabled')
    loadingIndicator.removeClass('d-none')
  }
  ajax = $.ajax({
    url: url.href,
    success: function(res) {
      let postListHtml = ''
      const postsInListRes = $(res).find('.post-wrap') || []
      const postsInResCount = postsInListRes.length
      const canLoadMore = postsInResCount === 6

      $.each(postsInListRes, function(index, post) {
        postListHtml += post.outerHTML
      })

      if (page === 1) {
        postList.find('.post-wrap').remove()
        if (postListHtml) {
          $('.resource-wrap').removeClass('d-none')
          $('.post-loading').addClass('d-none')
          postList.prepend(postListHtml)
          $('.no-posts-found').remove()
        } else {
          postList.html(`<p class="no-posts-found mx-auto"><b>${noPostsFoundMessage}</b></p>`)
        }
      } else {
        postList.append(postListHtml)
        loadMoreButton.removeAttr('disabled')
        loadingIndicator.addClass('d-none')
      }

      if (!canLoadMore) {
        loadMoreButton.addClass('d-none')
      } else {
        loadMoreButton.removeClass('d-none')
      }
      postBlock.attr('data-page', page)
    },
    error: function() {},
  })
}



// WEBPACK FOOTER //
// ./scripts/func/resource-filter.js